module.exports = __webpack_public_path__ + "img/Wp_2071.7c9237e4.png";